// core / app 
export const SET_LOADING = 'SET_LOADING';
export const SET_DATA = 'SET_DATA';
export const FILTER_DATA = 'FILTER_DATA';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_SORT = 'SET_SORT';
export const SET_MAP_VIEW = 'SET_MAP_VIEW';
export const TOGGLE_FILTER = 'TOGGLE_FILTER';
export const TOGGLE_OPTION = 'TOGGLE_OPTION';
export const UNSET_OPTIONS = 'UNSET_OPTIONS';
export const SET_RANGE = 'SET_RANGE';
export const RESET_RANGE = 'RESET_RANGE';
